import { config } from 'config';
import useSWRImmutable from 'swr/immutable';

export enum EdgeBNPLCapabilities {
  KLARNA = 'klarna_payments',
  AFFIRM = 'affirm_payments',
  AFTERPAY = 'afterpay_clearpay_payments',
}

export type RetrieveBNPLCapabilitiesResponse = {
  data: EdgeBNPLCapabilities[];
};

export const useBnplCapabilities = () => {
  const url = `${config.apiUrlV3}/web/capabilities`;

  return useSWRImmutable<RetrieveBNPLCapabilitiesResponse>(url);
};
